import React from 'react';

const KannadaContactDetails = () => {
    return (
        <div style={{ minHeight: '60vh', padding: '60px 20px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f9f9f9', textAlign: 'center' }}>
            <h1 style={{ fontSize: '2.5rem', color: '#5b1c1c', marginBottom: '20px' }}>Kannada Contact Details</h1>
            <p style={{ fontSize: '1.2rem', color: '#555', maxWidth: '800px' }}>
                This page is currently empty. Content will be updated soon.
            </p>
        </div>
    );
};

export default KannadaContactDetails;
